/* unplugin-vue-components disabled */import script from "./MyBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBalance.vue?vue&type=script&setup=true&lang=js"

import "./MyBalance.vue?vue&type=style&index=0&id=45d172e8&lang=scss"

const __exports__ = script;

export default __exports__